import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SpecialtyDal } from '../dal/specialty.dal';
import { Specialty } from '../models/specialty.model';

@Injectable({
  providedIn: 'root',
})
export class SpecialtyService {
  constructor(private specialtyDal: SpecialtyDal) {}

  getAllSpecialties(includeUrgence: boolean = false, delayTime: number = 0): Observable<Specialty[]> {
    return timer(delayTime).pipe(switchMap(() => this.specialtyDal.getAllSpecialties(includeUrgence)));
  }

  getAllSpecialtiesFromHospital(includeUrgence: boolean = false, hospital: string): Observable<Specialty[]> {
    return this.specialtyDal.getAllSpecialtiesFromHospital(includeUrgence, hospital);
  }

  getSharedSpecialties(): Observable<Specialty[]> {
    return this.specialtyDal.getSharedSpecialties();
  }

  addSpecialty(specialty: Specialty): Observable<Specialty> {
    return this.specialtyDal.addSpecialty(specialty);
  }

  updateSpecialty(specialty: Specialty): Observable<Specialty> {
    return this.specialtyDal.updateSpecialty(specialty);
  }

  isSpecialityExist(name: string) {
    return this.specialtyDal.getIsSpecialityExist(name);
  }

  deleteSpecialty(specialtyId: string) {
    return this.specialtyDal.deleteSpecialty(specialtyId);
  }

  softDeleteSpecialty(specialtyId: string) {
    return this.specialtyDal.softDeleteSpecialty(specialtyId);
  }

  softRestoreSpecialty(specialtyId: string) {
    return this.specialtyDal.softRestoreSpecialty(specialtyId);
  }

  getSimilarSpecialties(specialtyId: string) {
    return this.specialtyDal.getSimilarSpecialties(specialtyId);
  }
}
